import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import fallback from '../../assets/images/fallback.svg';
import { NextImage } from '../../components/internal/NextImage/NextImage.js';
import { Caption } from '../../components/PictureFallback/components/Caption.js';
import { Container } from '../../components/PictureFallback/components/Container.js';
export const PictureFallback = /*#__PURE__*/_styled(forwardRef(({
  caption = '',
  svg,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ...restProps,
    ref: ref,
    children: [_jsx(NextImage, {
      image: fallback,
      alt: caption,
      layout: svg ? 'intrinsic' : 'fill'
    }), caption && _jsx(Caption, {
      children: caption
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e8zef1t0"
} : {
  target: "e8zef1t0",
  label: "PictureFallback"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBpY3R1cmVGYWxsYmFjay5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTSSIsImZpbGUiOiJQaWN0dXJlRmFsbGJhY2suanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBmYWxsYmFjayBmcm9tICcuLi8uLi9hc3NldHMvaW1hZ2VzL2ZhbGxiYWNrLnN2Zyc7XG5pbXBvcnQgeyBOZXh0SW1hZ2UgfSBmcm9tICcuLi8uLi9jb21wb25lbnRzL2ludGVybmFsL05leHRJbWFnZS9OZXh0SW1hZ2UuanMnO1xuaW1wb3J0IHsgQ2FwdGlvbiB9IGZyb20gJy4uLy4uL2NvbXBvbmVudHMvUGljdHVyZUZhbGxiYWNrL2NvbXBvbmVudHMvQ2FwdGlvbi5qcyc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi9jb21wb25lbnRzL1BpY3R1cmVGYWxsYmFjay9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5leHBvcnQgY29uc3QgUGljdHVyZUZhbGxiYWNrID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgY2FwdGlvbiA9ICcnLCBzdmcsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICByZXR1cm4gKF9qc3hzKENvbnRhaW5lciwgeyAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjaGlsZHJlbjogW19qc3goTmV4dEltYWdlLCB7IGltYWdlOiBmYWxsYmFjaywgYWx0OiBjYXB0aW9uLCBsYXlvdXQ6IHN2ZyA/ICdpbnRyaW5zaWMnIDogJ2ZpbGwnIH0pLCBjYXB0aW9uICYmIF9qc3goQ2FwdGlvbiwgeyBjaGlsZHJlbjogY2FwdGlvbiB9KV0gfSkpO1xufSkpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UGljdHVyZUZhbGxiYWNrLmpzLm1hcCJdfQ== */");